import { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';

export function PWAUpdateDialog() {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);

  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, r) {
      if (r) {
        setInterval(
          () => r.update(),
          1000 * 60 * 10,
        );
      }
    },
  });

  useEffect(() => {
    if (needRefresh) {
      setOpen(true);
    }
  }, [needRefresh]);

  const handleConfirm = () => {
    updateServiceWorker(true);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t('newVersionAvailable')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('refreshThePage')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>{t('cancel')}</Button>
        <Button
          onClick={handleConfirm}
          startIcon={<RefreshIcon />}
          variant="contained"
          color="primary"
        >
          {t('refresh')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
